import React,{useState} from 'react'
import { PinDrop } from '@mui/icons-material'
import { Dialog, DialogContent } from '@mui/material'
import useCordinates from '../../../hooks/useCordinates';
import { useChatInputProvider } from './chat-context/ChatInputContext';


const ChatLocationPopup = ({dialogStatus,setDialogStatus, callBack}) =>{
    const cordinates = useCordinates();
    const sendLocation = () =>{
        if(navigator.geolocation){
			navigator.permissions.query({name:'geolocation'}).then(permissionStatus => {
				if (permissionStatus.state === 'denied') {
				  alert('Please allow location access.');
				  window.location.href = "app-settings:location";
				} else {
				  	//navigator.geolocation.getCurrentPosition(success, error);
				  	
                        callBack(cordinates);
                        setDialogStatus(false);
					
				}
			  });
		}
    }

    return (

        <Dialog
                open={dialogStatus}
                    keepMounted
                    onClose={()=>setDialogStatus(false)}
                    maxWidth="sm"
                    fullWidth={true}
            >
                <DialogContent>
                <div className="row">
                    {!cordinates && 
                        <span className='text-danger'>Please Allow Location Access to Continue</span>
                    }
                    {cordinates && 
                        <button className='btn btn-primary' onClick={sendLocation} >Share My Current Location</button>
                    }
                </div>
                </DialogContent>
            </Dialog>
    )

}

function ChatLocationInput({callBack}) {
    const {locationInputDialogStatus,setLocationInputDialogStatus} = useChatInputProvider();
    return (
        <>
            <a className="dropdown-item" href="#location"  onClick={()=>setLocationInputDialogStatus(true)}><PinDrop /> Location</a>
            {locationInputDialogStatus &&
            <ChatLocationPopup dialogStatus={locationInputDialogStatus} setDialogStatus={setLocationInputDialogStatus} callBack={callBack} />
            }
        </>
    )
}

export default ChatLocationInput